<template>
  <div>
    <form
      class="bg-white pt-6 pb-8 mb-4"
      @submit.prevent="updateProfile"
      enctype="multipart/form-data"
    >
      <div class="mb-4 w-full">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="name">Name</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="name"
          type="text"
          v-model="user.name"
        />
      </div>
      <div class="mb-4 w-full">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="email">Email</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="email"
          type="email"
          v-model="user.email"
        />
      </div>
      <div class="mb-4 w-full">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="about">{{ $t('About')}}</label>
        <textarea
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="about"
          v-model="user.about"
        ></textarea>
      </div>

      <div class="mb-4 w-full">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="phone">{{ $t('PhoneNumber')}}</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="phone"
          type="number"
          v-model="user.phone"
        />
      </div>
      <div class="mb-4 w-full">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="image">{{$t('Image')}}</label>
        <input
          type="file"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="image"
          @change="onFileChange"
        />
      </div>

      <div class="flex items-center">
        <button
          class="bg-teal-400 hover:bg-white hover:text-teal-400 text-white font-semibold py-2 px-4 focus:outline-none focus:shadow-outline"
          type="submit"
        >{{ $t('Update')}}</button>
        <router-link
          to="/profile"
          class="ml-10 inline-block align-baseline font-semibold text-sm text-teal-400 hover:text-teal-300"
        >{{ $t('Back')}}</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      user: {},
      id: this.$route.params.id
    };
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.get(`${process.env.VUE_APP_API}/user`).then(response => {
        this.user = response.data.data;
      });
    },
    onFileChange(event) {
      this.image = event.target.files[0];
    },
    updateProfile() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      // let formData = new FormData();
      // formData.append("image", this.image, this.image);

      axios
        .put(`${process.env.VUE_APP_API}/profile`, {
          name: this.user.name,
          about: this.user.about,
          phone: this.user.phone
          // formData
        })
        .then(
          this.$notify({
            group: "profile",
            title: "Profile",
            text: "Profil Profilaktualisierung"
          })
        )
        .then(this.$router.push("/profile"))
        .catch(error => console.log(error));
    }
  }
};
</script>

<style>
</style>